var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_16537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71536 7.68416L0.27631 6.17938C-0.11126 6.00993 -0.0850371 5.45146 0.316807 5.31925L13.3942 1.00816C13.7363 0.895474 14.0697 1.2009 13.9873 1.55178L11.374 12.6629C11.296 12.9949 10.8971 13.1303 10.6333 12.9142L7.5626 10.4017L3.71536 7.68416Z",
    fill: "#57C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8413 3.40722L3.71582 7.68383L4.58768 11.7279C4.66588 12.0908 5.09353 12.2507 5.3906 12.0282L7.56309 10.4013L5.77557 8.93847L11.0664 3.69687C11.2216 3.54317 11.0286 3.29481 10.8413 3.40722Z",
    fill: "#165274"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1425_16537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8413 3.40722L3.71582 7.68383L4.58768 11.7279C4.66588 12.0908 5.09353 12.2507 5.3906 12.0282L7.56309 10.4013L5.77557 8.93847L11.0664 3.69687C11.2216 3.54317 11.0286 3.29481 10.8413 3.40722Z",
    fill: "white",
    fillOpacity: 0.17
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 12.0833C5.03518 12.1557 5.23148 12.1463 5.39043 12.0272L7.56292 10.4003L6.66916 9.66892L5.7754 8.9375L4.875 12.0833Z",
    fill: "#2D89BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1425_16537",
    x: 1.81582,
    y: 1.47891,
    width: 11.2072,
    height: 12.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1425_16537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1425_16537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_16537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.90f7f1d25e3d2dc234734d35a5d49f56.svg";
export { ForwardRef as ReactComponent };